module.exports = __webpack_public_path__ + "img/2025-02-13c_3.4f7091fe.jpg";